import { ChangeEvent, Component, createRef } from 'react';

import { GenericMouseEvent } from '../../../types/types';
import styles from './checkbox.component.module.scss';


interface CheckboxProps {
    initialValue: boolean;
    ariaLabel: string,
    emitInitialValueOnInit: boolean;
    onChange?: (value: boolean) => void;
}

interface CheckboxState {
    value: boolean;
    prevInitialValue: boolean;
}

export default class Checkbox extends Component<CheckboxProps, CheckboxState> {
    container = createRef<HTMLDivElement>();
    handler: ((e: GenericMouseEvent) => void) | null = null;
    eventOffset = 0;

    valueFormatter = (val: number) => val;

    readonly state: Readonly<CheckboxState> = this.initializeAndGetState();

    constructor(props: CheckboxProps) {
        super(props);
    }

    initializeAndGetState() {
        return {
            value: this.props.initialValue,
            prevInitialValue: this.props.initialValue
        }
    }

    static getDerivedStateFromProps(props: CheckboxProps, state: CheckboxState) {
        if (props.initialValue !== state.prevInitialValue) {
            return {
                value: props.initialValue,
                prevInitialValue: props.initialValue
            };
        }
        return null;
    }

    componentDidMount() {
        if (this.props.onChange) {
            this.props.onChange(this.state.value);
        }
    }

    valueChanged(e: ChangeEvent<HTMLInputElement>): void {
        const value = !!(e.target as any).checked;
        this.setState({
            value: value,
        });

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }


    render() {
        return (
            <div ref={this.container} className={styles.container}>
                {/* UXM-03: a label around the switch, so on a coarse pointer the whole 44 px cell toggles it (the switch
                    itself is 22 px tall). The input keeps its aria-label as its name; the label adds no text.
                    A tap on the label itself is two clicks in the DOM (the label's, then the one it forwards to the
                    input); only the input's may reach a parent, so a parent that toggles on click ("Show All
                    Options") sees one click, exactly as for a tap on the switch. */}
                <label className={`form-check form-switch ${styles['input-container']}`}
                    onClick={e => { if (e.target === e.currentTarget) e.stopPropagation(); }}>
                    <input className="form-check-input"
                        type="checkbox"
                        checked={this.state.value}
                        onChange={e => this.valueChanged(e)}
                        aria-label={this.props.ariaLabel}
                    />
                </label>
            </div>
        );
    }
}